module.exports = __webpack_public_path__ + "5926d8c042f037865fc1ff4c25c5c042.png";